import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import store from '@/store/store'
import { useI18n } from 'vue-i18n-composable'
import { Icons } from '@/icons/icons'
import { ModuleNamespaces } from '@/store/types/storeGlobalTypes'
import { DialogData, DialogTypes } from '@/store/modules/dialog/dialogTypes'
import { useAuthStore } from '@/stores/auth/useAuthStore'
import useRouter from '@/composables/useRouter'


export default /*#__PURE__*/_defineComponent({
  __name: 'AvatarContextMenuComponent',
  setup(__props) {

const authModule = ModuleNamespaces.AUTH
const dialogModule: string = ModuleNamespaces.DIALOG

// TRANSLATIONS
const { t } = useI18n()
const text = {
  account: t('navigation.avatar_menu.account'),
  cancel: t('action_buttons.cancel'),
  closeDialogText: t('navigation.avatar_menu.close_dialog_text'),
  closeSession: t('navigation.avatar_menu.close_session')
}

const authStore = useAuthStore()
const router = useRouter()

// DATA
const myAccountUrl = process.env.VUE_APP_AREA_PERSONAL_URL
const icon = {
  arrow: Icons.ANGLE_RIGHT,
  close: Icons.CLOSE_SESSION
}

// GETTERS
const userName = computed(() => authStore.fullName || '')
const companyName = computed(() => authStore.company?.name)
const isPortalUser = computed(() => store.getters[`${authModule}/getIsPortalUser`])
const encryptedUserId = computed<string>(() => authStore.encryptedUserId)

// METHODS
async function redirect() {
  window.open(`${myAccountUrl}${encryptedUserId.value}`, '_blank')
}

function closeSession() {
  router.goToLogout()
}

async function showCloseSessionDialog() {
  const dialogData: DialogData = {
    action: () => closeSession(),
    mainButtonText: text.closeSession,
    message: text.closeDialogText as string,
    notMoveToTop: true,
    secondaryButtonText: text.cancel,
    type: DialogTypes.INFO
  }
  await store.dispatch(`${dialogModule}/showDialog`, dialogData)
}

return { __sfc: true,authModule, dialogModule, t, text, authStore, router, myAccountUrl, icon, userName, companyName, isPortalUser, encryptedUserId, redirect, closeSession, showCloseSessionDialog }
}

})